export const getUserPermissions = (user) => {
  if (!user) return [];
  const permissions = Array.isArray(user.permissions) ? user.permissions : [];
  const unique = new Set(permissions.filter(Boolean));
  return Array.from(unique);
};

export const getUserRoles = (user) => {
  if (!user) return [];
  const roles = Array.isArray(user.roles)
    ? user.roles
    : Array.isArray(user.Roles)
      ? user.Roles
      : [];
  const unique = new Set(
    roles
      .map((role) => (typeof role === 'string' ? role : role?.name))
      .filter(Boolean)
  );
  return Array.from(unique);
};

export const hasAdminRole = (user) => {
  if (!user) return false;
  return user.isAdmin === true || getUserRoles(user).includes('Admin');
};

export const isAdminUser = (user) => {
  if (!user) return false;
  if (hasAdminRole(user)) return true;
  const permissions = getUserPermissions(user);
  return permissions.includes("branch.access.any");
};

export const hasPermission = (user, permissionKey) => {
  if (!user || !permissionKey) return false;
  if (hasAdminRole(user)) return true;
  const permissions = getUserPermissions(user);
  return permissions.includes(permissionKey);
};

export const hasAnyPermission = (user, permissionKeys) => {
  if (!Array.isArray(permissionKeys) || !permissionKeys.length) return false;
  return permissionKeys.some((key) => hasPermission(user, key));
};
